import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import SignRiderTemplate from './SignRiderTemplate';

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    maxWidth: 600,
  },
});

const SignRiderReview = props => {
  const {
    classes,
    selectedPhoneNumber,
    selectedSignRiderSize,
    selectedSignRiderVariant,
    selectedSignRiderMaterial,
    selectedSignRiderGrommetHoles,
    signRiderTemplates,
    shippingAddress,
  } = props;

  const selectedTemplate = getSelectedSignRiderTemplate(
    signRiderTemplates,
    selectedSignRiderVariant
  );

  return (
    <div className={classes.root}>
      <Typography variant="headline" component="h3">
        Review your sign rider details:
      </Typography>
      <br />
      <br />
      <Typography variant="title">
        Your AgentBuzz phone number: {selectedPhoneNumber}
      </Typography>
      <br />
      <Typography variant="title">Your selected template:</Typography>
      <br />
      <SignRiderTemplate
        template={selectedTemplate}
        phoneNumber={selectedPhoneNumber}
      />
      <br />
      <br />
      <Typography variant="title">Your selected sign rider options:</Typography>
      <br />
      <Typography variant="subheading">
        Sign Rider Size: {selectedSignRiderSize}
      </Typography>
      <Typography variant="subheading">
        Sign Rider Material: {selectedSignRiderMaterial}
      </Typography>
      <Typography variant="subheading">
        Grommet Holes: {selectedSignRiderGrommetHoles}
      </Typography>
      <br />
      <br />
      <Typography variant="title">Your shipping details:</Typography>
      <br />
      <Typography variant="subheading">
        Name: {shippingAddress.name}
        <br />
        Address Line 1: {shippingAddress.line1}
        <br />
        Address Line 2: {shippingAddress.line2}
        <br />
        City: {shippingAddress.city}
        <br />
        State: {shippingAddress.state}
        <br />
        Zip: {shippingAddress.zip}
        <br />
      </Typography>
    </div>
  );
};

// Only to display a template to user, thus the size doesn't matter and is set to 24x6
function getSelectedSignRiderTemplate(templates, selectedSignRiderVariant) {
  return templates.filter(t => {
    return t.size === '24x6' && t.variant === selectedSignRiderVariant;
  })[0];
}
export default withStyles(styles)(SignRiderReview);



// WEBPACK FOOTER //
// ./src/components/SignRiderReview.js